import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Informacje dodatkowe',
  type: 'Rodzaj szkolenia',
  start: 'Rozpoczęcie',
  end: 'Zakończenie',
  localization: 'Lokalizacja',
  register: 'Zapisz się na szkolenie',
  seeOnMap: 'Zobacz na mapie',
});
